<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">HDDs Wipe Report</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-data-table
               v-model="selected"
                :loading='tableLoading'
                v-if='hddDetail'
                :headers="headers"
                :items="files"
                item-key="Time"
                :search="search"
                 select-all
              >
                <template v-slot:items="props">
                   <td>
        <v-checkbox
          v-model="props.selected"
          primary
          hide-details
        ></v-checkbox>
      </td>
                  <td class="text-xs-left">{{ props.item.Time }}</td>
                  <td class="text-xs-left">{{ props.item.Hddserial }}</td>
                   <td class="text-xs-left">{{ props.item.Passes }}</td>
                   <td class="text-xs-left">{{ props.item.Size }}</td>
                   <td class="text-xs-left">{{ props.item.Duration }}</td>
                    <td class="text-xs-left">{{ props.item.Conclusion }}</td>
                </template>
                <template v-slot:no-results>
                  <v-alert
                    :value="true"
                    color="error"
                    icon="warning"
                  >
                    Your search for "{{ search }}" found no results.
                  </v-alert>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          flat
          @click="dialog = false"
        >Close</v-btn>
        <HDDpdfExport
          :filesDetail="selected"
          :AssetTag="assetTag"
          :AssetDetail='asset'
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const fb = require("../../firebaseConfig.js");
import HDDpdfExport from "../HDDpdfExport"
export default {
  components: {
    HDDpdfExport
  },
  props: {
    assetTag: String,
  },
  mounted () {
    //this.listFiles()
    //this.getHDDdetail()
    this.getLotDetail()
    this.getAllreport();
    if(this.assetTag){
   fb.AssetsCollections.doc(this.assetTag).get().then(r=> this.asset = r.data());
      
    }
  },
  methods: {
    getAllreport(){
         fb.HDDWIPECollection.where("AssetTag", "==", this.assetTag).get().then(d => {
        d.forEach((doc) => {
          this.files.push(doc.data())
        })
      })
        this.selected = this.files;
       this.tableLoading = false
    },
    listFiles(){
      var storageRef = fb.storage.ref();
      var listRef = storageRef.child('killdiskreports/'+ this.assetTag);
      listRef.listAll().then((res)=> {
        res.items.forEach((itemRef) => {
          this.files.push({
            name : itemRef.name,
            fullPath : itemRef.fullPath
          })
        });
      this.tableLoading = false
      }).catch(function(error) {
        console.log(error)
      });
    },
    getLotDetail () {
      const Http = new XMLHttpRequest();
      const url = 'https://us-central1-tech-reuse.cloudfunctions.net/api/lot/assets/' + this.assetTag;
      Http.open("GET", url);
      Http.send();
      Http.onreadystatechange = () => {
        try {
          var temp = JSON.parse(Http.responseText)
          this.LotDetail = temp[0]
        }
        catch{
          return
        }
      }
    },
    getHDDdetail () {
      const Http = new XMLHttpRequest();
      const url = 'https://us-central1-tech-reuse.cloudfunctions.net/api/hddwipe/' + this.assetTag;
      Http.open("GET", url);
      Http.send();
      Http.onreadystatechange = () => {
        if (this.hddDetail.length === 0)
          try {
            var temp = JSON.parse(Http.responseText)
            this.hddDetail = Object.values(temp)
            this.tableLoading = false
          }
          catch{
            return
          }
      }
    },
  },
  data () {
    return {
      asset : null,
        selected: [],
      files : [],
      LotDetail: null,
      tableLoading: true,
      headers: [
        { text: 'Time', value: 'Time' },
       { text: 'Serial', value: 'Hddserial' },
       { text: 'Passes', value: 'Passes' },
       { text: 'Size', value: 'Size' },
        { text: 'Duration', value: 'Duration' },
       { text: 'Conclusion', value: 'Conclusion' },
      ],
      dialog: true,
      hddDetail: [],
      search: '',
    }
  },
  watch: {
    dialog: function (val) {
      if (val === false) {
        this.$emit("Modalclose");
      }
    }
  }
}
</script>

<style>
</style>
